<!-- 选择课价 -->
<template>
  <el-form-item :label="label">
    <yx-priceitem-selector
      @select="select"
      v-bind="config"
      ref="child"
      @clear="reset"
      width="222px"
    />
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-课价选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    config: {
      type: Object,
      default() {
        return {
          width: '220px',
        };
      },
    },
    params: {
      type: Object,
      default() {
        return {
          curriculumid: [],
        };
      },
    },
    label: {
      type: String,
      default: '课价：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    function reset() {
      child.value.clearField();
      // eslint-disable-next-line no-use-before-define
      priceItem.value = {};
    }
    const priceItem = useQuery('priceItem', props.value, reset);

    function select(obj) {
      priceItem.value = obj;
    }

    return {
      select,
      child,
      reset,
    };
  },
};
</script>
